import axios from 'axios'
import { api_lp, api } from '@/services/config'
import store from '@/store'
import { mixin } from '@/mixins/helper'
import router from '../../router'

const landingpage = {
  namespaced: true,
  state: () => ({
    start_step: false,
    profil_step: false,
    alamat_step: false,
    bank_step: false,
    afiliasi_step: false,
    legal_step: false,
    end_step: false,
    registerDone: false,
    pra_legal: false,

    md_step_1: [],
    md_step_2: [],
    md_step_3: [],
    md_step_4: [],
    md_step_5: [],
    md_step_6: [],
    md_step_7: [],

    globalLoading: false,
    activeLanding: 'instruction',
    query: 'bu',
    request_id: null,
    vendor_ref: null,
    userid: null,

    bidang_usaha_id: null,
    pendaftaran_id: null,
    tujuan_pendaftaran_id: null,
    type_pendaftaran_id: null,
    register_gems: null,
    register_bce: null,
    register_bkes: null,

    //profil
    badan_usaha_id: null,
    vendorName: '',
    tglBerdiri: '',
    addKbli: false,
    addedKbli: [],
    addIujp: false,
    addedIujp: [],
    addSbujk: false,
    addedSbujk: [],
    addIujptl: false,
    addedIujptl: [],
    addInubbm: false,
    addedInubbm: [],
    addSiupal: false,
    addedSiupal: [],

    //alamat
    choosedCountry: null,
    choosedProvince: null,
    choosedCity: null,
    choosedDistric: null,
    choosedVillage: null,
    kodepos: '',
    phoneCode: '',
    phoneNumber: '',
    emailPerusahaan: '',
    address: '',
    provinsiAsing: '',
    kotaAsing: '',

    //bank
    pemilikBank: '',
    selectedBankCountry: null,
    selectedBank: null,
    bankBranchOffice: '',
    accountNumber: '',
    mataUang: '',
    npwpBank: '',

    //afiliasi direktur
    addDirektur: false,
    editDirektur: false,
    direkturIndex: 0,
    idDirektur: '',
    jabatanDirektur: '',
    namaDirektur: '',
    phoneDirektur: '',
    emailDirektur: '',
    direkturFiles: [],
    direkturEditIndex: 0,
    direkturList: [],

    //afiliasi komisaris
    addKomisaris: false,
    editKomisaris: false,
    komisarisIndex: 0,
    idKomisaris: '',
    jabatanKomisaris: '',
    namaKomisaris: '',
    phoneKomisaris: '',
    emailKomisaris: '',
    komisarisFiles: [],
    komisarisEditIndex: 0,
    komisarisList: [],

    //afiliasi pemilikSaham
    addPemilikSaham: false,
    editPemilikSaham: false,
    pemilikSahamIndex: 0,
    idPemilikSaham: '',
    namaPemilikSaham: '',
    sahamPemilikSaham: '',
    pemilikSahamEditIndex: 0,
    pemilikSahamList: [],

    //afiliasi pic
    addPic: false,
    editPic: false,
    picIndex: 0,
    idPic: '',
    namaPic: '',
    phonePic: '',
    emailPic: '',
    picEditIndex: 0,
    picList: [],

    //hubungan dengan smm
    pick: '',
    afiliasi_gems: 0,
    afiliasi_bce: 0,
    afiliasi_bkes: 0,

    relasi_desc: '',
    relasi_group: '',
    relasi_jabatan: '',
    relasi_departemen: '',
    relasi_nama: '',

    // relasi_desc_gems: '',
    // relasi_group_gems: '',
    // relasi_jabatan_gems: '',
    // relasi_departemen_gems: '',
    // relasi_nama_gems: '',

    // relasi_desc_bce: '',
    // relasi_group_bce: '',
    // relasi_jabatan_bce: '',
    // relasi_departemen_bce: '',
    // relasi_nama_bce: '',

    // relasi_desc_bkes: '',
    // relasi_group_bkes: '',
    // relasi_jabatan_bkes: '',
    // relasi_departemen_bkes: '',
    // relasi_nama_bkes: '',

    //legalitas
    addAktaPerusahaan: false,
    addedAktaPerusahaan: [],
    addKomersial: false,
    addedKomersial: [],
    addPerizinan: false,
    addedPerizinan: [],

    logoFiles: [],
    logoFileName: '',
    paktaFiles: [],
    paktaFileName: '',
    formulirFiles: [],
    formulirFileName: '',
    suratFiles: [],
    suratFileName: '',
    komitmenKplhFiles: [],
    komitmenKplhFileName: '',

    ktpFiles: [],
    ktpFileName: '',
    npwpFiles: [],
    npwpFileName: '',
    kkFiles: [],
    kkFileName: '',
    coverFiles: [],
    coverFileName: '',
    adaRekomendasi: true,
    rekomendasiFiles: [],
    rekomendasiFileName: '',
    adaRekening: true,
    rekeningFiles: [],
    rekeningFileName: '',

    legalDocument: [],
    allLegal: [],
  }),
  mutations: {
    MD_STEP_UPDATE(state, payload) {
      let step = state[payload.step]
      state[payload.step][payload.index][payload.name] = payload.value
    },
    RESET_LANDING_PAGE(state) {
      state.start_step = false
      state.profil_step = false
      state.alamat_step = false
      state.bank_step = false
      state.afiliasi_step = false
      state.legal_step = false
      state.end_step = false
      state.registerDone = false

      state.globalLoading = false
      state.activeLanding = 'instruction'
      state.query = null
      state.request_id = null
      state.userid = null

      state.bidang_usaha_id = null
      state.pendaftaran_id = null
      state.tujuan_pendaftaran_id = null
      state.type_pendaftaran_id = null
      state.register_gems = null
      state.register_bce = null
      state.register_bkes = null
    },
    UPDATE_INFORMASI(state, info) {
      state.vendorName = info.nama_vendor
      state.badan_usaha_id = mixin.methods.$get(info, 'badan_usaha.id')
      state.tglBerdiri = mixin.methods.formatDateInput(info.tanggal_berdiri)

      let storeKbli = []
      for (let i in info.kbli) {
        let newKbli = info.kbli[i].kbli_sub
        newKbli['nib'] = info.kbli[i].nib
        newKbli['ss_izin'] = info.kbli[i].ss_izin
        newKbli['dokumen_lainnya'] = info.kbli[i].dokumen_lainnya

        storeKbli.push(newKbli)
      }
      state.addedKbli = storeKbli

      if (info.iujp && info.iujp.length > 0) {
        let storeIujp = []
        for (let iujp in info.iujp) {
          let newIujp = info.iujp[iujp].master_iujp
          if (newIujp) {
            newIujp['checked'] = true
            storeIujp.push(newIujp)
          }
        }
        state.addedIujp = storeIujp
      }

      if (info.iujptl && info.iujptl.length > 0) {
        let storeIujptl = []
        for (let iujptl in info.iujptl) {
          let newIujp = info.iujptl[iujptl].master_iujptl
          newIujp['checked'] = true
          storeIujptl.push(newIujp)
        }
        state.addedIujptl = storeIujptl
      }

      if (info.sbujk && info.sbujk.length > 0) {
        let storeSbujk = []
        for (let sbujk in info.sbujk) {
          let newSbujk = info.sbujk[sbujk].master_sbujk
          newSbujk['checked'] = true
          storeSbujk.push(newSbujk)
        }
        state.addedSbujk = storeSbujk
      }

      if (info.inu_bbm && info.inu_bbm.length > 0) {
        let storeInuBbm = []
        for (let inu_bbm in info.inu_bbm) {
          let newInuBbm = info.inu_bbm[inu_bbm].master_inu_bbm
          newInuBbm['checked'] = true
          storeInuBbm.push(newInuBbm)
        }
        state.addedInubbm = storeInuBbm
      }

      if (info.siupal && info.siupal.length > 0) {
        let storeSiupal = []
        for (let siupal in info.siupal) {
          let newSiupal = info.siupal[siupal].master_siupal
          newSiupal['checked'] = true
          storeSiupal.push(newSiupal)
        }
        state.addedSiupal = storeSiupal
      }

      state.choosedCountry = info.negara
      state.choosedProvince = info.provinsi
      state.choosedCity = info.kota
      state.choosedDistric = info.kecamatan
      state.choosedVillage = info.kelurahan
      state.kodepos = mixin.methods.$get(info, 'kelurahan.kodepos')

      state.phoneNumber = info.no_handphone

      const getPhoneCode = () => {
        let splitPhoneNumber = info.no_handphone.split(' ')
        if (splitPhoneNumber.length > 1) {
          state.phoneCode = splitPhoneNumber[0]
          state.phoneNumber = splitPhoneNumber.slice(1).join(' ')
        } else {
          state.phoneCode = '+' + info.negara.kode_telepon
          state.phoneNumber = info.no_handphone.replace(state.phoneCode, '')
        }
      }

      if (info && info.negara && info.negara.id != 63) {
        getPhoneCode()
        state.kodepos = mixin.methods.$get(info, 'kode_pos_asing')
        state.provinsiAsing = mixin.methods.$get(info, 'provinsi_asing')
        state.kotaAsing = mixin.methods.$get(info, 'kota_asing')
      } else {
        getPhoneCode()
      }

      state.emailPerusahaan = info.email
      state.address = info.alamat

      state.pemilikBank = info.nama_pemilik_rekening
      state.selectedBank = info.bank
      state.bankBranchOffice = info.kantor_cabang
      state.accountNumber = info.no_rekening
      state.mataUang = info.mata_uang
      state.npwpBank = info.no_npwp

      if (info.direktur && info.direktur.length > 0) {
        let storeDirektur = []
        for (let direktur in info.direktur) {
          let newDirektur = info.direktur[direktur]
          newDirektur['phoneNumber'] = info.direktur[direktur].no_handphone
          storeDirektur.push(newDirektur)
        }
        state.direkturList = storeDirektur
      }

      if (info.komisaris && info.komisaris.length > 0) {
        let storeKomisaris = []
        for (let komisaris in info.komisaris) {
          let newKomisaris = info.komisaris[komisaris]
          newKomisaris['phoneNumber'] = info.komisaris[komisaris].no_handphone
          storeKomisaris.push(newKomisaris)
        }
        state.komisarisList = storeKomisaris
      }

      if (info.pemilik_saham && info.pemilik_saham.length > 0) {
        let storePemilikSaham = []
        for (let pemilik_saham in info.pemilik_saham) {
          let newPemilikSaham = info.pemilik_saham[pemilik_saham]
          newPemilikSaham['saham'] = info.pemilik_saham[pemilik_saham].persen
          storePemilikSaham.push(newPemilikSaham)
        }
        state.pemilikSahamList = storePemilikSaham
      }

      if (info.pic && info.pic.length > 0) {
        let storePic = []
        for (let pic in info.pic) {
          let newPic = info.pic[pic]
          newPic['emailPic'] = info.pic[pic].email
          newPic['phoneNumber'] = info.pic[pic].no_handphone
          storePic.push(newPic)
        }
        state.picList = storePic
      }

      if (info.afiliasi_bce || info.afiliasi_gems || info.afiliasi_bkes) {
        state.pick = 'ya'
      } else {
        state.pick = 'tidak'
      }

      state.afiliasi_gems = info.afiliasi_gems
      state.afiliasi_bce = info.afiliasi_bce
      state.afiliasi_bkes = info.afiliasi_bkes

      state.relasi_desc = info.relasi_desc_bce
      state.relasi_group = info.relasi_group_bce
      state.relasi_jabatan = info.relasi_jabatan_bce
      state.relasi_departemen = info.relasi_departemen_bce
      state.relasi_nama = info.relasi_nama_bce
    },

    UPDATE_LEGAL(state, legal) {
      for (let i in legal) {
        legal[i] = {
          ...legal[i],
          id: legal[i].legal_document_id,
        }
      }
      state.allLegal = legal
      let akta = legal.filter(i => i.type == 1)
      let komersial = legal.filter(i => i.type == 2 && i.legal_document_id != 7)
      let perizinan = legal.filter(i => i.type == 3)

      let activeAkta = akta.filter(i => i.lampiran)
      let newAkta = []
      for (let i in activeAkta) {
        let tmp = activeAkta[i]
        tmp['id'] = activeAkta[i].legal_document_id
        tmp['checked'] = true
        tmp['keterangan'] = activeAkta[i].no_dokumen
        tmp['start_date'] = mixin.methods.formatDateInput(
          activeAkta[i].tanggal_efektif
        )
        tmp['end_date'] = mixin.methods.formatDateInput(
          activeAkta[i].tanggal_berakhir
        )
        tmp['fileName'] = activeAkta[i].lampiran

        newAkta.push(tmp)
      }
      state.addedAktaPerusahaan = newAkta

      let activeKomersial = komersial.filter(i => i.lampiran)
      let newKomersial = []
      for (let i in activeKomersial) {
        let tmp = activeKomersial[i]
        tmp['id'] = activeKomersial[i].legal_document_id
        tmp['checked'] = true
        tmp['keterangan'] = activeKomersial[i].no_dokumen
        tmp['start_date'] = mixin.methods.formatDateInput(
          activeKomersial[i].tanggal_efektif
        )
        tmp['end_date'] = mixin.methods.formatDateInput(
          activeKomersial[i].tanggal_berakhir
        )
        tmp['fileName'] = activeKomersial[i].lampiran

        newKomersial.push(tmp)
      }
      state.addedKomersial = newKomersial

      let activePerizinan = perizinan.filter(i => i.lampiran)
      let newPerizinan = []
      for (let i in activePerizinan) {
        let tmp = activePerizinan[i]
        tmp['id'] = activePerizinan[i].legal_document_id
        tmp['checked'] = true
        tmp['keterangan'] = activePerizinan[i].no_dokumen
        tmp['start_date'] = mixin.methods.formatDateInput(
          activePerizinan[i].tanggal_efektif
        )
        tmp['end_date'] = mixin.methods.formatDateInput(
          activePerizinan[i].tanggal_berakhir
        )
        tmp['fileName'] = activePerizinan[i].lampiran

        newPerizinan.push(tmp)
      }
      state.addedPerizinan = newPerizinan

      let getLogoFileName = legal.filter(i => i.legal_document_id == 44)
      state.logoFileName = getLogoFileName && getLogoFileName[0].lampiran

      let getPaktaFileName = legal.filter(i => i.legal_document_id == 31)
      state.paktaFileName = getPaktaFileName && getPaktaFileName[0].lampiran

      let getFormulirFileName = legal.filter(i => i.legal_document_id == 32)
      state.formulirFileName =
        getFormulirFileName && getFormulirFileName[0].lampiran

      let getSuratFileName = legal.filter(i => i.legal_document_id == 7)
      state.suratFileName = getSuratFileName && getSuratFileName[0].lampiran

      let getKomitmenKplhFileName = legal.filter(i => i.legal_document_id == 33)
      state.komitmenKplhFileName =
        getKomitmenKplhFileName && getKomitmenKplhFileName[0].lampiran

      let getKtpFileName = legal.filter(i => i.legal_document_id == 27)
      state.ktpFileName = getKtpFileName && getKtpFileName[0].lampiran

      let getNpwpFileName = legal.filter(i => i.legal_document_id == 5)
      state.npwpFileName = getNpwpFileName && getNpwpFileName[0].lampiran

      let getKkFileName = legal.filter(i => i.legal_document_id == 28)
      state.kkFileName = getKkFileName && getKkFileName[0].lampiran

      let getCoverFileName = legal.filter(i => i.legal_document_id == 34)
      state.coverFileName =
        getCoverFileName &&
        getCoverFileName.length > 0 &&
        getCoverFileName[0].lampiran

      let getRekomendasiFileName = legal.filter(i => i.legal_document_id == 29)
      state.rekomendasiFileName =
        getRekomendasiFileName && getRekomendasiFileName[0].lampiran

      state.adaRekomendasi =
        getRekomendasiFileName && getRekomendasiFileName[0].lampiran
          ? true
          : false

      let getRekeningFileName = legal.filter(i => i.legal_document_id == 30)
      state.rekeningFileName =
        getRekeningFileName && getRekeningFileName[0].lampiran
      state.adaRekening =
        getRekeningFileName && getRekeningFileName[0].lampiran ? true : false
    },
    SET_NEED_REVIEW(state) {
      state.profil_step = true
      state.alamat_step = true
      state.bank_step = true
      state.afiliasi_step = true
      state.legal_step = true
      state.end_step = true
    },
    PRA_LEGAL(state) {
      state.pra_legal = true
    },
    SET_LANDINGPAGE_FORM(state, name) {
      state.activeLanding = name
    },
    SET_LANDING_ROUTER(state, query) {
      state.query = query
    },
    SET_LANDINGPAGE_MODAL(state, modal) {
      state[modal.name] = modal.status
    },
    SET_CHECKED(state, checked) {
      state[checked.name] = checked.filter
    },
    SET_STATE_DATA(state, data) {
      state[data.name] = data.value
    },
    SET_ARRAY_DATA(state, data) {
      if (data.operation == 'add') {
        state[data.name] = [...state[data.name], data.value]
      }

      if (data.operation == 'delete') {
        let filterData = state[data.name].filter(i => i.id !== data.value)
        state[data.name] = state[data.name].filter(i => i.id !== data.value)

        filterData.push(data.deleted)
        state[data.name] = filterData
      }

      if (data.operation == 'edit') {
        for (let i in state[data.name]) {
          if (state[data.name][i].id == data.value.id) {
            state[data.name][i]['id'] = data.value.id
            state[data.name][i]['jabatan'] = data.value.jabatan
            state[data.name][i]['nama'] = data.value.nama
            state[data.name][i]['phoneNumber'] = data.value.phoneNumber
            state[data.name][i]['email'] = data.value.email
            state[data.name][i]['saham'] = data.value.saham
            state[data.name][i]['direkturFiles'] = data.value.direkturFiles
            state[data.name][i]['komisarisFiles'] = data.value.komisarisFiles
            break
          }
        }
      }

      if (data.operation == 'wipe') {
        if (data.name == 'direkturList') {
          state.direkturIndex = 0
        }
        if (data.name == 'komisarisList') {
          state.komisarisIndex = 0
        }
        state[data.name] = []
      }
    },
    COMBINE_LEGAL_DOC(state, payload) {
      let data

      if (payload && payload.badan == 'bu') {
        let legalBu = [
          ...state.addedAktaPerusahaan,
          ...state.addedKomersial,
          ...state.addedPerizinan,
          {
            id: 44,
            desc: '',
            file: state.logoFiles,
            fileName: '',
            folder: '',
            start_date: '',
            end_date: '',
          },
          {
            id: 31,
            desc: '',
            file: state.paktaFiles,
            fileName: '',
            folder: '',
            start_date: '',
            end_date: '',
          },
          {
            id: 32,
            desc: '',
            file: state.formulirFiles,
            fileName: '',
            folder: '',
            start_date: '',
            end_date: '',
          },
          {
            id: 7,
            desc: '',
            file: state.suratFiles,
            fileName: '',
            folder: '',
            start_date: '',
            end_date: '',
          },
        ]

        let object = []

        for (let i in legalBu) {
          if (payload && payload.review) {
            object.push(legalBu[i])
          } else {
            if (legalBu[i] && legalBu[i].file && legalBu[i].file.length > 0) {
              object.push(legalBu[i])
            }
          }
        }

        state.legalDocument = object
      } else {
        let legalPerorangan = [
          {
            id: 27,
            desc: '',
            file: state.ktpFiles,
            fileName: '',
            folder: '',
            start_date: '',
            end_date: '',
          },
          {
            id: 5,
            desc: '',
            file: state.npwpFiles,
            fileName: '',
            folder: '',
            start_date: '',
            end_date: '',
          },
          {
            id: 28,
            desc: '',
            file: state.kkFiles,
            fileName: '',
            folder: '',
            start_date: '',
            end_date: '',
          },
          {
            id: 34,
            desc: '',
            file: state.coverFiles,
            fileName: '',
            folder: '',
            start_date: '',
            end_date: '',
          },
          {
            id: 29,
            desc: '',
            file: state.rekomendasiFiles,
            fileName: '',
            folder: '',
            start_date: '',
            end_date: '',
          },
          {
            id: 30,
            desc: '',
            file: state.rekeningFiles,
            fileName: '',
            folder: '',
            start_date: '',
            end_date: '',
          },

          {
            id: 44,
            desc: '',
            file: state.logoFiles,
            fileName: '',
            folder: '',
            start_date: '',
            end_date: '',
          },
          {
            id: 31,
            desc: '',
            file: state.paktaFiles,
            fileName: '',
            folder: '',
            start_date: '',
            end_date: '',
          },
          {
            id: 32,
            desc: '',
            file: state.formulirFiles,
            fileName: '',
            folder: '',
            start_date: '',
            end_date: '',
          },
          {
            id: 7,
            desc: '',
            file: state.suratFiles,
            fileName: '',
            folder: '',
            start_date: '',
            end_date: '',
          },
          {
            id: 33,
            desc: '',
            file: state.komitmenKplhFiles,
            fileName: '',
            folder: '',
            start_date: '',
            end_date: '',
          },
        ]

        let object = []

        for (let i in legalPerorangan) {
          if (payload && payload.review) {
            object.push(legalPerorangan[i])
          } else {
            if (
              legalPerorangan[i] &&
              legalPerorangan[i].file &&
              legalPerorangan[i].file.length > 0
            ) {
              object.push(legalPerorangan[i])
            }
          }
        }

        state.legalDocument = object
      }
    },
    async SEND_REGISTER_DATA(state, payload) {
      state.globalLoading = true

      let newLegal = []
      if (payload && payload.process == 'review') {
        let oldCombineLegal = [...state.allLegal, ...state.legalDocument]
        newLegal = [
          ...oldCombineLegal
            .reduce((map, obj) => map.set(obj.id, obj), new Map())
            .values(),
        ]
      } else {
        newLegal = state.legalDocument
      }

      const dataRegister = {
        request_id: state.request_id,
        tujuan_pendaftaran_id: state.tujuan_pendaftaran_id,
        pendaftaran_id: state.pendaftaran_id,
        badan_usaha_id: state.badan_usaha_id,
        afiliasi_bce: state.afiliasi_bce ? 1 : 0,
        afiliasi_gems: state.afiliasi_gems ? 1 : 0,
        afiliasi_bkes: state.afiliasi_bkes ? 1 : 0,

        nama_vendor: state.vendorName,
        tanggal_berdiri: state.tglBerdiri,
        inu_bbm_id:
          state.addedInubbm.length > 0 &&
          Object.values(
            state.addedInubbm.reduce((a, b) => ({ ...a, [b.id]: b.id }), {})
          ),
        iujp_id:
          state.addedIujp.length > 0 &&
          Object.values(
            state.addedIujp.reduce((a, b) => ({ ...a, [b.id]: b.id }), {})
          ),
        iujptl_id:
          state.addedIujptl.length > 0 &&
          Object.values(
            state.addedIujptl.reduce((a, b) => ({ ...a, [b.id]: b.id }), {})
          ),
        sbujk_id:
          state.addedSbujk.length > 0 &&
          Object.values(
            state.addedSbujk.reduce((a, b) => ({ ...a, [b.id]: b.id }), {})
          ),
        siupal_id:
          state.addedSiupal.length > 0 &&
          Object.values(
            state.addedSiupal.reduce((a, b) => ({ ...a, [b.id]: b.id }), {})
          ),
        kbli_parent_id:
          state.addedKbli.length > 0 &&
          Object.values(
            state.addedKbli.reduce(
              (a, b) => ({ ...a, [b.id]: b.parent_id }),
              {}
            )
          ),
        kbli_sub_id:
          state.addedKbli.length > 0 &&
          Object.values(
            state.addedKbli.reduce((a, b) => ({ ...a, [b.id]: b.id }), {})
          ),
        kbli_nib:
          state.addedKbli.length > 0 &&
          Object.values(
            state.addedKbli.reduce((a, b) => ({ ...a, [b.id]: b.nib }), {})
          ),
        kbli_ss_izin:
          state.addedKbli.length > 0 &&
          Object.values(
            state.addedKbli.reduce((a, b) => ({ ...a, [b.id]: b.ss_izin }), {})
          ),
        kbli_dokumen_lainnya:
          state.addedKbli.length > 0 &&
          Object.values(
            state.addedKbli.reduce(
              (a, b) => ({ ...a, [b.id]: b.dokumen_lainnya }),
              {}
            )
          ),

        alamat: state.address,
        negara_id: state.choosedCountry && state.choosedCountry.id,
        provinsi_id: state.choosedProvince && state.choosedProvince.id,
        provinsi_asing: state.provinsiAsing,
        kota_id: state.choosedCity && state.choosedCity.id,
        kota_asing: state.kotaAsing,
        kecamatan_id: state.choosedDistric && state.choosedDistric.id,
        kelurahan_id: state.choosedVillage && state.choosedVillage.id,
        kode_pos_asing: state.kodepos,
        no_handphone: state.phoneNumber,
        email: state.emailPerusahaan,

        nama_pemilik_rekening: state.pemilikBank,
        bank: state.selectedBank,
        kantor_cabang: state.bankBranchOffice,
        no_rekening: state.accountNumber,
        mata_uang: state.mataUang,
        no_npwp: state.npwpBank,

        direktur_jabatan:
          state.direkturList.length > 0 &&
          Object.values(
            state.direkturList.reduce(
              (a, b) => ({ ...a, [b.id]: b.jabatan }),
              {}
            )
          ),
        direktur_nama:
          state.direkturList.length > 0 &&
          Object.values(
            state.direkturList.reduce((a, b) => ({ ...a, [b.id]: b.nama }), {})
          ),
        direktur_no_handphone:
          state.direkturList.length > 0 &&
          Object.values(
            state.direkturList.reduce(
              (a, b) => ({ ...a, [b.id]: b.phoneNumber }),
              {}
            )
          ),
        direktur_email:
          state.direkturList.length > 0 &&
          Object.values(
            state.direkturList.reduce((a, b) => ({ ...a, [b.id]: b.email }), {})
          ),
        direktur_lampiran:
          state.direkturList.length > 0 &&
          Object.values(
            state.direkturList.reduce(
              (a, b) => ({ ...a, [b.id]: b.direkturFiles }),
              {}
            )
          ),

        komisaris_jabatan:
          state.komisarisList.length > 0 &&
          Object.values(
            state.komisarisList.reduce(
              (a, b) => ({ ...a, [b.id]: b.jabatan }),
              {}
            )
          ),
        komisaris_nama:
          state.komisarisList.length > 0 &&
          Object.values(
            state.komisarisList.reduce((a, b) => ({ ...a, [b.id]: b.nama }), {})
          ),
        komisaris_no_handphone:
          state.komisarisList.length > 0 &&
          Object.values(
            state.komisarisList.reduce(
              (a, b) => ({ ...a, [b.id]: b.phoneNumber }),
              {}
            )
          ),
        komisaris_email:
          state.komisarisList.length > 0 &&
          Object.values(
            state.komisarisList.reduce(
              (a, b) => ({ ...a, [b.id]: b.email }),
              {}
            )
          ),
        komisaris_lampiran:
          state.komisarisList.length > 0 &&
          Object.values(
            state.komisarisList.reduce(
              (a, b) => ({ ...a, [b.id]: b.komisarisFiles }),
              {}
            )
          ),

        pemilik_saham_nama:
          state.pemilikSahamList.length > 0 &&
          Object.values(
            state.pemilikSahamList.reduce(
              (a, b) => ({ ...a, [b.id]: b.nama }),
              {}
            )
          ),
        pemilik_saham_persen:
          state.pemilikSahamList.length > 0 &&
          Object.values(
            state.pemilikSahamList.reduce(
              (a, b) => ({ ...a, [b.id]: b.saham }),
              {}
            )
          ),
        pic_nama:
          state.picList.length > 0 &&
          Object.values(
            state.picList.reduce((a, b) => ({ ...a, [b.id]: b.nama }), {})
          ),
        pic_no_handphone:
          state.picList.length > 0 &&
          Object.values(
            state.picList.reduce(
              (a, b) => ({ ...a, [b.id]: b.phoneNumber }),
              {}
            )
          ),
        pic_email:
          state.picList.length > 0 &&
          Object.values(
            state.picList.reduce((a, b) => ({ ...a, [b.id]: b.email }), {})
          ),
        legal_document_id:
          newLegal.length > 0 &&
          Object.values(
            newLegal.reduce((a, b) => ({ ...a, [b.id]: b.id ? b.id : '' }), {})
          ),
        legal_document_fileName:
          newLegal.length > 0 &&
          Object.values(
            newLegal.reduce(
              (a, b) => ({ ...a, [b.id]: b.fileName ? b.fileName : null }),
              {}
            )
          ),
        legal_document_checked:
          newLegal.length > 0 &&
          Object.values(
            newLegal.reduce(
              (a, b) => ({ ...a, [b.id]: b.checked ? true : false }),
              {}
            )
          ),
        legal_document_tanggal_efektif:
          newLegal.length > 0 &&
          Object.values(
            newLegal.reduce(
              (a, b) => ({ ...a, [b.id]: b.start_date ? b.start_date : '' }),
              {}
            )
          ),
        legal_document_tanggal_berakhir:
          newLegal.length > 0 &&
          Object.values(
            newLegal.reduce(
              (a, b) => ({ ...a, [b.id]: b.end_date ? b.end_date : '' }),
              {}
            )
          ),
        legal_document_no:
          newLegal.length > 0 &&
          Object.values(
            newLegal.reduce(
              (a, b) => ({ ...a, [b.id]: b.keterangan ? b.keterangan : '' }),
              {}
            )
          ),
        legal_document_lampiran:
          newLegal.length > 0 &&
          Object.values(
            newLegal.reduce(
              (a, b) => ({
                ...a,
                [b.id]: b.file && b.file.length > 0 ? b.file : [],
              }),
              {}
            )
          ),
      }

      let md_step_2 = state.md_step_2.map((item, index) => {
        if (index !== 1 || index !== 2) {
          return {
            ...item,
          }
        }
      })
      let md_step_3 = state.md_step_3.map((item, index) => {
        if (index !== 1 || index !== 2) {
          return {
            ...item,
          }
        }
      })
      let md_step_4 = state.md_step_4.map((item, index) => {
        if (index !== 1 || index !== 2) {
          return {
            ...item,
          }
        }
      })
      let md_step_5 = state.md_step_5.map((item, index) => {
        if (index !== 1 || index !== 2) {
          return {
            ...item,
          }
        }
      })
      let md_step_6 = state.md_step_6.map((item, index) => {
        if (index !== 1 || index !== 2) {
          return {
            ...item,
          }
        }
      })

      dataRegister.md_step = [
        ...md_step_2,
        ...md_step_3,
        ...md_step_4,
        ...md_step_5,
        ...md_step_6,
      ]

      if (state.afiliasi_gems || state.afiliasi_bce || state.afiliasi_bkes) {
        dataRegister.relasi_nama_bce = state.relasi_nama
        dataRegister.relasi_desc_bce = state.relasi_desc
        dataRegister.relasi_group_bce = state.relasi_group
        dataRegister.relasi_jabatan_bce = state.relasi_jabatan
        dataRegister.relasi_departemen_bce = state.relasi_departemen
      }

      let bodyFormData = new FormData()
      state.userid && bodyFormData.append('user_id', state.userid)
      dataRegister.request_id &&
        bodyFormData.append('request_id', dataRegister.request_id)
      dataRegister.pendaftaran_id &&
        bodyFormData.append('pendaftaran_id', dataRegister.pendaftaran_id)
      dataRegister.tujuan_pendaftaran_id &&
        bodyFormData.append(
          'tujuan_pendaftaran_id',
          dataRegister.tujuan_pendaftaran_id
        )
      dataRegister.badan_usaha_id &&
        bodyFormData.append('badan_usaha_id', dataRegister.badan_usaha_id)

      bodyFormData.append('afiliasi_bce', dataRegister.afiliasi_bce)
      bodyFormData.append('afiliasi_gems', dataRegister.afiliasi_gems)
      bodyFormData.append('afiliasi_bkes', dataRegister.afiliasi_bkes)

      dataRegister.nama_vendor &&
        bodyFormData.append('nama_vendor', dataRegister.nama_vendor)
      dataRegister.tanggal_berdiri &&
        bodyFormData.append('tanggal_berdiri', dataRegister.tanggal_berdiri)

      if (
        dataRegister.inu_bbm_id.length > 0 &&
        dataRegister.inu_bbm_id.length
      ) {
        for (let i in dataRegister.inu_bbm_id) {
          bodyFormData.append(
            'inu_bbm_id[]',
            dataRegister.inu_bbm_id[i] ? dataRegister.inu_bbm_id[i] : []
          )
        }
      }

      if (dataRegister.iujp_id.length > 0 && dataRegister.iujp_id.length) {
        for (let i in dataRegister.iujp_id) {
          bodyFormData.append(
            'iujp_id[]',
            dataRegister.iujp_id[i] ? dataRegister.iujp_id[i] : []
          )
        }
      }

      if (dataRegister.iujptl_id.length > 0 && dataRegister.iujptl_id.length) {
        for (let i in dataRegister.iujptl_id) {
          bodyFormData.append(
            'iujptl_id[]',
            dataRegister.iujptl_id[i] ? dataRegister.iujptl_id[i] : []
          )
        }
      }

      if (dataRegister.sbujk_id.length > 0 && dataRegister.sbujk_id.length) {
        for (let i in dataRegister.sbujk_id) {
          bodyFormData.append(
            'sbujk_id[]',
            dataRegister.sbujk_id[i] ? dataRegister.sbujk_id[i] : []
          )
        }
      }

      if (dataRegister.siupal_id.length > 0 && dataRegister.siupal_id.length) {
        for (let i in dataRegister.siupal_id) {
          bodyFormData.append(
            'siupal_id[]',
            dataRegister.siupal_id[i] ? dataRegister.siupal_id[i] : []
          )
        }
      }

      if (
        dataRegister.kbli_parent_id.length > 0 &&
        dataRegister.kbli_parent_id.length
      ) {
        for (let i in dataRegister.kbli_parent_id) {
          bodyFormData.append(
            'kbli_parent_id[]',
            dataRegister.kbli_parent_id[i] ? dataRegister.kbli_parent_id[i] : []
          )
          bodyFormData.append(
            'kbli_sub_id[]',
            dataRegister.kbli_sub_id[i] ? dataRegister.kbli_sub_id[i] : []
          )
          bodyFormData.append('kbli_nib[]', dataRegister.kbli_nib[i] ? 1 : 0)
          bodyFormData.append(
            'kbli_ss_izin[]',
            dataRegister.kbli_ss_izin[i] ? 1 : 0
          )
          bodyFormData.append(
            'kbli_dokumen_lainnya[]',
            dataRegister.kbli_dokumen_lainnya[i] ? 1 : 0
          )
        }
      }

      dataRegister.alamat && bodyFormData.append('alamat', dataRegister.alamat)
      dataRegister.negara_id &&
        bodyFormData.append('negara_id', dataRegister.negara_id)
      dataRegister.provinsi_id &&
        bodyFormData.append('provinsi_id', dataRegister.provinsi_id)
      dataRegister.provinsi_asing &&
        bodyFormData.append('provinsi_asing', dataRegister.provinsi_asing)
      dataRegister.kota_id &&
        bodyFormData.append('kota_id', dataRegister.kota_id)
      dataRegister.kota_asing &&
        bodyFormData.append('kota_asing', dataRegister.kota_asing)
      dataRegister.kecamatan_id &&
        bodyFormData.append('kecamatan_id', dataRegister.kecamatan_id)
      dataRegister.kelurahan_id &&
        bodyFormData.append('kelurahan_id', dataRegister.kelurahan_id)
      dataRegister.kode_pos_asing &&
        bodyFormData.append('kode_pos_asing', dataRegister.kode_pos_asing)
      dataRegister.no_handphone &&
        bodyFormData.append('no_handphone', dataRegister.no_handphone)
      dataRegister.email && bodyFormData.append('email', dataRegister.email)

      dataRegister.nama_pemilik_rekening &&
        bodyFormData.append(
          'nama_pemilik_rekening',
          dataRegister.nama_pemilik_rekening
        )
      dataRegister.bank && bodyFormData.append('bank', dataRegister.bank)
      dataRegister.kantor_cabang &&
        bodyFormData.append('kantor_cabang', dataRegister.kantor_cabang)
      dataRegister.no_rekening &&
        bodyFormData.append('no_rekening', dataRegister.no_rekening)
      dataRegister.mata_uang &&
        bodyFormData.append('mata_uang', dataRegister.mata_uang)
      dataRegister.no_npwp &&
        bodyFormData.append('no_npwp', dataRegister.no_npwp)

      dataRegister.relasi_nama_bce &&
        bodyFormData.append('relasi_nama_bce', dataRegister.relasi_nama_bce)
      dataRegister.relasi_desc_bce &&
        bodyFormData.append('relasi_desc_bce', dataRegister.relasi_desc_bce)
      dataRegister.relasi_group_bce &&
        bodyFormData.append('relasi_group_bce', dataRegister.relasi_group_bce)
      dataRegister.relasi_jabatan_bce &&
        bodyFormData.append(
          'relasi_jabatan_bce',
          dataRegister.relasi_jabatan_bce
        )
      dataRegister.relasi_departemen_bce &&
        bodyFormData.append(
          'relasi_departemen_bce',
          dataRegister.relasi_departemen_bce
        )

      if (
        dataRegister.direktur_jabatan.length > 0 &&
        dataRegister.direktur_jabatan.length
      ) {
        for (let i in dataRegister.direktur_jabatan) {
          bodyFormData.append(
            'direktur_jabatan[]',
            dataRegister.direktur_jabatan[i]
              ? dataRegister.direktur_jabatan[i]
              : []
          )
          bodyFormData.append(
            'direktur_nama[]',
            dataRegister.direktur_nama[i] ? dataRegister.direktur_nama[i] : []
          )
          bodyFormData.append(
            'direktur_no_handphone[]',
            dataRegister.direktur_no_handphone[i]
              ? dataRegister.direktur_no_handphone[i]
              : []
          )
          bodyFormData.append(
            'direktur_email[]',
            dataRegister.direktur_email[i] ? dataRegister.direktur_email[i] : []
          )
          bodyFormData.append(
            'direktur_lampiran[]',
            dataRegister.direktur_lampiran[i]
              ? dataRegister.direktur_lampiran[i][0]
              : []
          )
          bodyFormData.append(
            'direktur_lampiran_isupdate[]',
            dataRegister.direktur_lampiran[i] &&
              dataRegister.direktur_lampiran[i].length > 0
              ? 1
              : 0
          )
        }
      }

      if (
        dataRegister.komisaris_jabatan.length > 0 &&
        dataRegister.komisaris_jabatan.length
      ) {
        for (let i in dataRegister.komisaris_jabatan) {
          bodyFormData.append(
            'komisaris_jabatan[]',
            dataRegister.komisaris_jabatan[i]
              ? dataRegister.komisaris_jabatan[i]
              : []
          )
          bodyFormData.append(
            'komisaris_nama[]',
            dataRegister.komisaris_nama[i] ? dataRegister.komisaris_nama[i] : []
          )
          bodyFormData.append(
            'komisaris_no_handphone[]',
            dataRegister.komisaris_no_handphone[i]
              ? dataRegister.komisaris_no_handphone[i]
              : []
          )
          bodyFormData.append(
            'komisaris_email[]',
            dataRegister.komisaris_email[i]
              ? dataRegister.komisaris_email[i]
              : []
          )
          bodyFormData.append(
            'komisaris_lampiran[]',
            dataRegister.komisaris_lampiran[i]
              ? dataRegister.komisaris_lampiran[i][0]
              : []
          )
          bodyFormData.append(
            'komisaris_lampiran_isupdate[]',
            dataRegister.komisaris_lampiran[i] &&
              dataRegister.komisaris_lampiran[i].length > 0
              ? 1
              : 0
          )
        }
      }

      if (
        dataRegister.pemilik_saham_nama.length > 0 &&
        dataRegister.pemilik_saham_nama.length
      ) {
        for (let i in dataRegister.pemilik_saham_nama) {
          bodyFormData.append(
            'pemilik_saham_nama[]',
            dataRegister.pemilik_saham_nama[i]
              ? dataRegister.pemilik_saham_nama[i]
              : []
          )
          bodyFormData.append(
            'pemilik_saham_persen[]',
            dataRegister.pemilik_saham_persen[i]
              ? dataRegister.pemilik_saham_persen[i]
              : []
          )
        }
      }

      if (dataRegister.pic_nama.length > 0 && dataRegister.pic_nama.length) {
        for (let i in dataRegister.pic_nama) {
          bodyFormData.append(
            'pic_nama[]',
            dataRegister.pic_nama[i] ? dataRegister.pic_nama[i] : []
          )
          bodyFormData.append(
            'pic_no_handphone[]',
            dataRegister.pic_no_handphone[i]
              ? dataRegister.pic_no_handphone[i]
              : []
          )
          bodyFormData.append(
            'pic_email[]',
            dataRegister.pic_email[i] ? dataRegister.pic_email[i] : []
          )
        }
      }

      function isDeleted(checked, fileName) {
        if (!checked && fileName) {
          return 2
        }

        return 0
      }

      if (
        dataRegister.legal_document_id &&
        dataRegister.legal_document_id.length > 0
      ) {
        for (let i in dataRegister.legal_document_lampiran) {
          if (
            dataRegister.legal_document_id[i] &&
            dataRegister.legal_document_id[i] != 35 &&
            dataRegister.legal_document_id[i] != 36
          ) {
            bodyFormData.append(
              'legal_document_id[]',
              dataRegister.legal_document_id[i]
                ? dataRegister.legal_document_id[i]
                : ''
            )
            bodyFormData.append(
              'legal_document_tanggal_efektif[]',
              dataRegister.legal_document_tanggal_efektif[i]
                ? dataRegister.legal_document_tanggal_efektif[i]
                : ''
            )
            bodyFormData.append(
              'legal_document_tanggal_berakhir[]',
              dataRegister.legal_document_tanggal_berakhir[i]
                ? dataRegister.legal_document_tanggal_berakhir[i]
                : ''
            )
            bodyFormData.append(
              'legal_document_no[]',
              dataRegister.legal_document_no[i]
                ? dataRegister.legal_document_no[i]
                : ''
            )
            bodyFormData.append(
              'legal_document_lampiran[]',
              dataRegister.legal_document_lampiran[i] &&
                dataRegister.legal_document_lampiran[i].length > 0
                ? dataRegister.legal_document_lampiran[i][0]
                : ''
            )
            bodyFormData.append(
              'legal_document_lampiran_isupdate[]',
              dataRegister.legal_document_lampiran[i] &&
                dataRegister.legal_document_lampiran[i].length > 0
                ? 1
                : isDeleted(
                    dataRegister.legal_document_checked[i],
                    dataRegister.legal_document_fileName[i]
                  )
            )
          }
        }
      }

      if (dataRegister.md_step.length > 0) {
        for (let i in dataRegister.md_step) {
          if (
            dataRegister.md_step[i].is_active &&
            !dataRegister.md_step[i].is_default &&
            dataRegister.md_step[i].question_type !== 'attachment'
          ) {
            bodyFormData.append(
              'md_landing_form_id[]',
              dataRegister.md_step[i] ? dataRegister.md_step[i].id : ''
            )
            bodyFormData.append(
              'name[]',
              dataRegister.md_step[i] ? dataRegister.md_step[i].name : ''
            )
            bodyFormData.append(
              'md_landing_step_id[]',
              dataRegister.md_step[i]
                ? dataRegister.md_step[i].md_landing_step_id
                : ''
            )
            bodyFormData.append(
              'question_type[]',
              dataRegister.md_step[i]
                ? dataRegister.md_step[i].question_type
                : ''
            )
            bodyFormData.append(
              'text[]',
              dataRegister.md_step[i] ? dataRegister.md_step[i].text : ''
            )
            bodyFormData.append(
              'form_value[]',
              dataRegister.md_step[i]
                ? dataRegister.md_step[i].form_value
                  ? dataRegister.md_step[i].form_value
                  : ''
                : ''
            )
            bodyFormData.append(
              'form_sub_value[]',
              dataRegister.md_step[i]
                ? dataRegister.md_step[i].form_sub_value
                  ? dataRegister.md_step[i].form_sub_value
                  : ''
                : ''
            )
            bodyFormData.append(
              'is_active[]',
              dataRegister.md_step[i] ? dataRegister.md_step[i].is_active : ''
            )
            bodyFormData.append(
              'is_mandatory[]',
              dataRegister.md_step[i]
                ? dataRegister.md_step[i].is_mandatory
                : ''
            )
          }
        }
      }

      state.type_pendaftaran_id &&
        bodyFormData.append('type_pendaftaran_id', state.type_pendaftaran_id)
      state.bidang_usaha_id &&
        bodyFormData.append('bidang_usaha_id', state.bidang_usaha_id)

      if (payload && payload.process == 'review') {
        let url_review = `${api}/api/v1/request/feedback/${state.request_id}`
        if (state.pra_legal) {
          bodyFormData.append('vendor_id', state.vendor_ref)
          url_review = `${api}/api/v1/request/feedback-legal/${state.request_id}`
        }

        axios({
          method: 'PUT',
          url: url_review,
          data: bodyFormData,
          headers: { 'Content-Type': 'multipart/form-data' },
        })
          .then(function({ data }) {
            state.globalLoading = false
            state.registerDone = true
            store.commit('SET_NOTIF', data.message)
            store.commit('landingpage/RESET_LANDING_PAGE')

            // if (payload.process == 'review' && !state.pra_legal) {
            //   router.push({ path: '/approval' })
            // }
          })
          .catch(function(response) {
            state.globalLoading = false
            store.commit(
              'SET_NOTIF',
              mixin.methods.$get(response, 'data.message', 'Error')
            )
          })
      } else {
        axios({
          method: 'POST',
          url: `${api_lp}/api/v1/vendor`,
          data: bodyFormData,
          headers: { 'Content-Type': 'multipart/form-data' },
        })
          .then(function({ data }) {
            state.globalLoading = false
            state.registerDone = true
            store.commit('SET_NOTIF', data.message)

            // if (payload.process == 'review') {
            //   router.push({ path: '/approval' })
            // }
          })
          .catch(function(response) {
            state.globalLoading = false
            store.commit(
              'SET_NOTIF',
              mixin.methods.$get(response, 'data.message', 'Error')
            )
          })
      }
    },
  },
  actions: {
    async getAllForms({ commit, state }) {
      try {
        const url = `${api}/api/v1/md-landing-forms?is_active=1&bidang_usaha_id=${state.bidang_usaha_id}&type_pendaftaran_id=${state.type_pendaftaran_id}&page=1&limit=100000`
        state.globalLoading = true

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          state.globalLoading = false
          let forms = data.data
          for (let form of forms) {
            switch (form.md_landing_step_id) {
              case 1:
                state.md_step_1.push(form)
                break
              case 2:
                state.md_step_2.push(form)
                break
              case 3:
                state.md_step_3.push(form)
                break
              case 4:
                state.md_step_4.push(form)
                break
              case 5:
                state.md_step_5.push(form)
                break
              case 6:
                state.md_step_6.push(form)
                break
              case 7:
                state.md_step_7.push(form)
                break
            }
          }
        } else {
          throw new Error('Form not found')
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        state.globalLoading = false
      }
    },
    async getAnswer({ commit, state }) {
      try {
        const url = `${api}/api/v1/md-landing-data?request_id=${state.request_id}&is_active=1&page=1&limit=100000`
        state.globalLoading = true

        const { data } = await axios({
          method: 'GET',
          url,
        })

        const getStep = (step, id, form_value, form_sub_value) => {
          let allStep = state[`md_step_${step}`]

          let arrStep = []
          for (let i in allStep) {
            let newStep = allStep[i]
            if (allStep[i].id == id) {
              newStep.form_value = form_value
              newStep.form_sub_value = form_sub_value
            }

            arrStep.push(newStep)
          }
        }

        if (data && data.status == 'success') {
          state.globalLoading = false
          let answers = data.data
          for (let answer of answers) {
            let step = answer.md_landing_step_id
            getStep(
              step,
              answer.md_landing_form_id,
              answer.form_value,
              answer.form_sub_value
            )
          }
        } else {
          throw new Error('Form not found')
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        state.globalLoading = false
      }
    },
  },
}

export default landingpage
